import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";
import axios from "axios";
import { connect } from "react-redux";

import { withTranslation } from "react-i18next";

const CurrencyPicker = ({
  t,
  allowNone,
  className,
  disabled,
  id,
  onChange,
  size,
  userinfo,
}) => {
  const [currecies, setCurrecies] = useState([]);

  useEffect(() => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    load(source);
    return () => {
      source.cancel("Cancel");
    };
  }, [id]);

  const load = async (source) => {
    const { culture } = userinfo;
    try {
      const res = await axios({
        url: `api/user/currency-active/${culture}`,
        cancelToken: source.token,
        method: "GET",
      });
      setCurrecies(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <Input
        type="select"
        bsSize={size || "md"}
        value={id}
        onChange={onChange}
        className={className || ""}
        disabled={disabled || false}
      >
        {(id === 0 || allowNone) && (
          <option value={0}>{t("CurrencyPicker.chooseCurrency")}</option>
        )}
        {currecies.map((currency) => (
          <option key={currency.currency} value={currency.currency}>
            {currency.description}
          </option>
        ))}
      </Input>
    </div>
  );
};

CurrencyPicker.propTypes = {
  allowNone: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  t: PropTypes.func,
  userinfo: PropTypes.object,
};

const mapStateToProps = ({ user: { userinfo } }) => userinfo;

export default connect(
  mapStateToProps,
  null
)(withTranslation()(CurrencyPicker));
